import { render, staticRenderFns } from "./comp_Transbank-Payment-InstructionsCardContent.vue?vue&type=template&id=28b771b9&"
import script from "./comp_Transbank-Payment-InstructionsCardContent.vue?vue&type=script&lang=js&"
export * from "./comp_Transbank-Payment-InstructionsCardContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports